import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { buildDealerScopeSearch } from '../utils/dealerScopeParams';

/**
 * `navigate()` для showroom-flow, сохраняющий dealer-scope query-параметры
 * (`?token` / `organizationId` / `inventorySlug`) при переходе.
 *
 * ЗАЧЕМ единый хук, а не inline на каждом call-site: на standalone-демо дилер
 * резолвится ТОЛЬКО из URL при загрузке (см. utils/dealerScopeParams.js). Голый
 * `navigate('/cars/:id/landing')` переписывает hash и роняет `?token` → reload
 * падает в «Car not found». Раскопировать перенос по каждому `navigate` легко
 * забыть (так и было пропущено лого в SalonHeader) — поэтому правило живёт в
 * одном месте: любой переход внутри showroom-flow идёт через этот хук.
 *
 * @returns {(pathname: string) => void} navigate по pathname с перенесённым
 *   dealer-scope search из текущего location.
 */
export const useDealerScopeNavigate = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  return useCallback(
    (pathname) => navigate({ pathname, search: buildDealerScopeSearch(search) }),
    [navigate, search],
  );
};
